import { printMenuCross } from './functions-print-menu-cross';
import { menuCrossHover } from './functions-menu-cross';

export const menuCross = (menuData) => {
  import('./style.css').then(
    () => {
      if (window.tc_vars.env_channel === 'desktop' || window.tc_vars.env_channel === 'tablet') {
        jQuery('#container-header #header').append('<div id="menu-cross-wraper"></div>');
        jQuery('#menu-cross-wraper').prepend('<div id="menu-cross" class="menu-cross"></div>');
        printMenuCross(menuData, jQuery('#menu-cross'));
        menuCrossHover(menuData);
        /* lazyload menu-cross images */
        cube.lazyload.init();
      }
    }
  );
};



// WEBPACK FOOTER //
// ./src/_override/shared/menu-cross/menu-cross.js